try {
    window.$ = window.jQuery = require('jquery');
    window.Swal = require("sweetalert2");
    window.select2 = require('select2');
} catch (e) {
}


// Product try-on and other inline page controls need the Bootstrap modal API.
// Expose it explicitly; `require()` alone does not create a browser global.
window.bootstrap = require('bootstrap');

require('lazyload')

import PhotoSwipeLightbox from './files/photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from './files/photoswipe/dist/photoswipe.esm.js';

require('owl.carousel')

window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipe = PhotoSwipe;

window.addEventListener("load", (event) => {
    $('.nav-link-home').addClass('show');
});

import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()


$(function () {
    $('.brand_slider .owl-carousel').owlCarousel({
        stagePadding: 50,
        rtl: true,
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1.5,
                stagePadding: 5,
            },
            400: {
                items: 2
            },
            768: {
                items: 3
            },
            1200: {
                items: 3
            }
        }
    });

    document.addEventListener("scroll", (event) => {
        let lastKnownScrollPosition = window.scrollY;
        if (lastKnownScrollPosition >= 100) {
            $('#sectionLogoHeader').addClass('hide-header-logo')
        } else {
            $('#sectionLogoHeader').removeClass('hide-header-logo')
        }
    });

    window.addEventListener('sweetAlert', function (e) {

        Swal.fire({
            title: e.detail.title,
            icon: e.detail.icon,
            toast: true,
            showConfirmButton: false,
            position: 'top-right',
            timer: 3000
        });
    });

    window.addEventListener('tooltip', function (e) {
        $('[data-toggle="tooltip"]').tooltip()
    });


    window.addEventListener('closeModal', function (e) {
        $('#' + e.detail).modal('hide');
    })


    window.addEventListener('openModal', function (e) {
        $('#' + e.detail).modal('show');
    })

    window.addEventListener('select2', function (e) {
        $('.js-example-basic-multiple').select2();
    });

    $('#featureProductSection .owl-carousel').owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 0,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
    });
    $('#owlCarouselFeatureProduct .owl-carousel').owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 0,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
    })

    window.addEventListener('FeatureProductCarousel', function (e) {
        const owl = $('#owlCarouselFeatureProduct'); // Owl carousel in question
        $(owl).trigger('destroy.owl.carousel'); // Destroy carousel instance
        $(owl).html($(owl).find('.owl-stage-outer').html()).removeClass('owl-loaded'); // Destroy carousel instance part 2
        $(owl).owlCarousel({
            loop: false,
            rtl: true,
            center: false,
            margin: 0,
            autoWidth: true,
            nav: true,
            dots: false,
            navText: [
                "<i class='fas fa-chevron-right'></i>",
                "<i class='fas fa-chevron-left'></i>"
            ],
            autoplay: false,
        }); // Initialize Owl carousel once again with same config options
    });

    // اسلایدر از سمت سرور رندر می‌شود؛ هم در لود صفحه و هم بعد از رندر Livewire فقط یک بار راه‌اندازی شود
    function initHomeSlider() {
        const slider = $('#slider-carousel .owl-carousel:not(.owl-loaded)');
        if (!slider.length)
            return;

        slider.owlCarousel({
            loop: true,
            rtl: true,
            center: true,
            margin: 0,
            nav: true,
            dots: true,
            autoplayTimeout: 3500,
            navText: [
                "<i class='fas fa-chevron-right'></i>",
                "<i class='fas fa-chevron-left'></i>"
            ],
            autoplay: true,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1
                }
            }
        })
    }

    initHomeSlider();
    window.addEventListener('SliderCarousel', initHomeSlider);

    window.addEventListener('SliderCarouselMobile', function (e) {
        $('#slider-carousel .owl-carousel').owlCarousel({
            loop: true,
            rtl: true,
            center: true,
            margin: 0,
            nav: true,
            dots: true,
            autoplayTimeout: 3500,
            navText: [
                "<i class='fas fa-chevron-right'></i>",
                "<i class='fas fa-chevron-left'></i>"
            ],
            autoplay: true,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1
                }
            }
        })
    });

});


$(document).ready(function () {
    $('#loginModal').on('shown.bs.modal', function () {
        $('#mobile').focus();
    });
    $('#searchModal').on('shown.bs.modal', function () {
        $('#inputSearchHeader').focus();
    });

    // Enable Bootstrap tooltips on page load
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="popover"]').popover();

    // Ensure Livewire updates re-instantiate tooltips
    if (typeof window.Livewire !== 'undefined') {
        window.Livewire.hook('message.processed', (message, component) => {
            $('[data-bs-toggle="tooltip"]').tooltip('dispose').tooltip();
            $('[data-bs-toggle="popover"]').popover('dispose').popover();
        });
    }


    function setCartOpen(open) {
        if (!open && document.activeElement?.closest('.mini-cart')) {
            document.querySelector('.btn-cart-header')?.focus();
        }
        $('.mini-cart').toggleClass('show', open).prop('inert', !open);
        $('.btn-cart-header').attr('aria-expanded', String(open));
        document.body.classList.toggle('site-cart-open', open);
        if (open) {
            window.dispatchEvent(new Event('site-close-widgets'));
            document.querySelector('.mini-cart .btn-cart-header')?.focus();
        }
    }
    setCartOpen(false);
    $(document).on('click', '.btn-cart-header', function (event) {
        event.preventDefault();
        setCartOpen(!document.body.classList.contains('site-cart-open'));
    });
    document.addEventListener('pointerdown', function (event) {
        if (!event.target.closest('.mini-cart, .btn-cart-header')) setCartOpen(false);
    });
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('site-cart-open')) {
            setCartOpen(false);
            document.querySelector('.btn-cart-header')?.focus();
        }
    });
    // Keep only one Bootstrap focus trap and backdrop active during transitions.
    let activeModal = null;
    let pendingModal = null;
    let modalReady = false;
    document.addEventListener('show.bs.modal', function (event) {
        if (activeModal && activeModal !== event.target) {
            event.preventDefault();
            pendingModal = event.target;
            if (modalReady) window.bootstrap.Modal.getInstance(activeModal)?.hide();
            return;
        }
        activeModal = event.target;
        modalReady = false;
        setCartOpen(false);
        window.dispatchEvent(new Event('site-close-widgets'));
        document.body.classList.add('site-modal-open');
    });
    document.addEventListener('shown.bs.modal', function (event) {
        modalReady = true;
        if (pendingModal) window.bootstrap.Modal.getInstance(event.target)?.hide();
    });
    document.addEventListener('hidden.bs.modal', function (event) {
        if (event.target !== activeModal) return;
        activeModal = null;
        modalReady = false;
        document.body.classList.remove('site-modal-open');
        $('.card-fixed').removeClass('stop-scrolling');
        const next = pendingModal;
        pendingModal = null;
        if (next?.isConnected) window.bootstrap.Modal.getOrCreateInstance(next).show();
    });

    jQuery('.btn-tire-filter').click(function (e) {
        e.preventDefault();
        let target = $(this).attr('data-tab');
        $('.btn-tire-filter').removeClass('active');
        $('.tab-tire-filter').addClass('d-none');
        $(this).addClass('active');
        $(target).removeClass('d-none');
    });
    jQuery('.set-filter-tire-tab').change(function (e) {
        e.preventDefault();
        let target = $(this).attr('data-tab');
        Livewire.emit('set-tire-filter-tab', target)
    });

    jQuery(document).on("click", ".btn-tab-feature-product", function (e) {
        e.preventDefault();
        let btnTabs = $('.btn-tab-feature-product');
        let tab = $(this).attr('data-tab');

        if ($(this).hasClass('active'))
            return;

        $('#featureProductSection').addClass('d-none');
        btnTabs.removeClass('active');
        $(this).addClass('active')
        $('#loadingFeatureProduct').removeClass('d-none')
        Livewire.emit('set-tab-feature-product', tab);

    });

    jQuery(document).on("click", ".btn-set-previous-page", function (e) {
        let url = $(this).attr('data-previous')
        if (url)
            Livewire.emit('setPreviousPage', url);
        else
            Livewire.emit('setPreviousPage', null);
    });


    $('#inputSearchHeader').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMember(value), 500)
    });

    let timeoutID = null;

    function findMember(str) {

        $('#spinnerLoadingSearch').removeClass('d-none');
        $('#loadingSearch').removeClass('d-none');
        Livewire.emit('set-query-search-modal', str);
    }


    $('#inputSearchSidebar').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMemberSideBar(value), 500)
    });


    function findMemberSideBar(str) {

        $('#spinnerLoadingSearchSidebar').removeClass('d-none');
        $('#preloadProductsList').removeClass('d-none');
        Livewire.emit('set-query-search-sidebar', str);
    }

    $('#inputSearchBrand').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMemberBrand(value), 500)
    });


    function findMemberBrand(str) {

        $('#preloadBrandList').removeClass('d-none');
        Livewire.emit('set-query-search-brand', str);
    }

    $("#rangeComment").on("input change", function () {
        let value = $("#rangeComment").val();
        document.getElementById('notActiveRangeComment').style.width = (100 - value * 20) + '%';
        document.getElementById('activeRangeComment').style.width = value * 20 + '%';
    });


    jQuery(document).on("click", ".btn-comment-like-product", function (e) {
        e.preventDefault();
        let likeMove = jQuery(this).closest('.btn-comment-like-product');
        let dataId = likeMove.attr('data-id');
        let count = likeMove.attr('data-count');
        Livewire.emit('comment-like-product', dataId, 'like');
        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas fa-thumbs-up ms-1 fa-lg"></i> ' + ++count);
            let dislike = jQuery('#btn-dislike-' + dataId).attr('data-count');

            if (jQuery('#btn-dislike-' + dataId).children('i').get(0).classList.contains('fas')) {
                --dislike;
                console.log(dislike);
                jQuery('#btn-dislike-' + dataId).attr('data-count', dislike);
            }

            jQuery('#btn-dislike-' + dataId).html('<i class="far ms-1 fa-thumbs-down fa-lg"></i> ' + dislike);
            likeMove.attr('data-count', count);
        } else {
            jQuery(this).html('<i class="far fa-thumbs-up ms-1 fa-lg"></i> ' + --count);
            likeMove.attr('data-count', count);
        }
    });

    jQuery(document).on("click", ".btn-comment-dislike-product", function (e) {
        e.preventDefault();
        let dislikeMove = jQuery(this).closest('.btn-comment-dislike-product');
        let dataId = dislikeMove.attr('data-id');
        let count = dislikeMove.attr('data-count');
        Livewire.emit('comment-like-product', dataId, 'dislike');

        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas fa-thumbs-down ms-1 fa-lg"></i> ' + ++count);
            var like = jQuery('#btn-like-' + dataId).attr('data-count');

            if (jQuery('#btn-like-' + dataId).children('i').get(0).classList.contains('fas')) {
                --like;
                console.log(like);
                jQuery('#btn-like-' + dataId).attr('data-count', like);
            }

            jQuery('#btn-like-' + dataId).html('<i class="far fa-thumbs-up ms-1 fa-lg"></i> ' + like);
            dislikeMove.attr('data-count', count);
        } else {
            jQuery(this).html('<i class="far fa-thumbs-down ms-1 fa-lg"></i> ' + --count);
            dislikeMove.attr('data-count', count);
        }
    });

    jQuery(document).on("change", ".form-select", function (e) {
        e.preventDefault();
        if ($(this).val()) {
            $('.price-product-view').html('<small>درحال بروزرسانی...</small>')
            $('.btn-submit').html('<small>درحال بررسی...</small>')
        }


        $('.btn-submit').addClass('disabled')
        $(this).find().remove();
    });

    let s=document.getElementsByTagName('a');
    let show = function(e){
        // $('#preloaderMobile').removeClass('d-none');
    }
    for (let i=0;i<s.length;i++)
    {
        s[i].onclick = show;
    }
});


$(document).ready(function () {

    const gallerySite = new PhotoSwipeLightbox({
        gallery: '#gallerySite',
        children: 'a',
        pswpModule: PhotoSwipe
    });

    gallerySite.init();

    const galleryMobile = new PhotoSwipeLightbox({
        gallery: '#galleryMobile',
        children: 'a',
        pswpModule: PhotoSwipe
    });

    galleryMobile.init();

    $('.product-scroll .owl-carousel').owlCarousel({
        stagePadding: 0,
        rtl: true,
        loop: true,
        lazy:true,
        margin: 5,
        nav: true,
        dots: true,
        autoplay: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        responsive: {
            0: {
                items: 1,
            }
        }


    });
});
